import { NgClass } from '@angular/common';
import { Component, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { HtmlSanitizerPipe } from '@ecm/material';

import { Legal } from '../../../../business/api/dashboardV7/legal';

@Component({
    selector: 'megapush-legal-modal',
    templateUrl: 'megapush-legal-modal.html',
    standalone: true,
    imports: [NgClass, HtmlSanitizerPipe, TranslateModule],
    host: { '[class]': 'textColor ?? ""' },
})
export class MegapushLegalModalComponent {
    public readonly activeModal = inject(NgbActiveModal);
    public readonly translateService = inject(TranslateService);
    public legal!: Legal;
    public textColor?: string;
    protected readonly isArray = Array.isArray;
}
